import React from 'react';
import { Route } from 'react-router-dom'
import ListPublicaciones from './Components/ListPublicaciones';
import PublicacionNew from './Components/ABM/PublicacionNew'; 
import PublicacionEdit from './Components/ABM/PublicacionEdit'
import CreacionMasivaPublicaciones from './Components/Excel/CreacionMasivaPublicaciones';
import ActualizacionMasivaPublicaciones from './Components/Excel/ActualizacionMasivaPublicaciones';

export default class AdmPublicaciones extends React.Component {
    render () {
        return (
            <div>
                <Route exact path="/Publicaciones" component={ListPublicaciones}/>
                <Route exact path="/Publicaciones/Nueva/:idSeller" component={PublicacionNew}/>
                <Route exact path="/Publicaciones/Editar/:idSeller/:id" component={PublicacionEdit}/>
                <Route exact path="/Publicaciones/CreacionMasiva" component={CreacionMasivaPublicaciones}/>
                <Route exact path="/Publicaciones/ActualizacionMasiva" component={ActualizacionMasivaPublicaciones} />
                
            </div>
        ); 
    }
}